const MatrixType = Object.freeze({
  PRIORITY: 'PRIORITY',
  ALIGNMENT: 'ALIGNMENT',
});

export default MatrixType;
